import { Component, Input } from "@angular/core";
import { ILastPlayedGame, INewGame } from "src/app/interfaces/player-dashboard.interface";
import { ConfigService } from "src/app/services/config/config.service";
import { GameHubControllerService } from "src/app/services/gameHub/game-hub-controller";
import { Navigator } from 'src/app/components/menu/navigator';

@Component({
    selector: 'app-games-section',
    templateUrl: './games-section.component.html',
    styleUrls: ['./games-section.component.scss'],
})
export class GamesSectionComponent {
    @Input() lastGames: Array<ILastPlayedGame>;
    @Input() newGames: Array<INewGame>;

    public imagePath: string;

    public get newGamesList(): Array<INewGame> {
        if (this.lastGames?.length) {
            const lastGames = this.lastGames.length === 1 ? 2 : this.lastGames.length;
            const count = 7 - lastGames;
            return this.newGames.slice(0, count);
        }

        return this.newGames;
    }

    constructor(
        private gameHubControllerService: GameHubControllerService,
        private config: ConfigService,
        private navigator: Navigator,
    ) {
        this.imagePath = this.config.getConfig().CDN_BASEURL + '/assets/social/games/';
    }

    public openGame(gameData: INewGame | ILastPlayedGame) {
        this.navigator.dismissAll();
        this.gameHubControllerService.launchCasinoGame(gameData);
    }
}